/** @format */

import { useEffect, useState, useMemo } from "react";
import { Spinner, Table } from "reactstrap";
import http from "../../../services/http";
import { getAPIURL, getVendorSettings } from "../../../services/helper";
import ReportPrintHeader from "../components/ReportPrintHeader";
import { useParams } from "react-router-dom";

const api_url = getAPIURL();

export default function EODByPayTypesPrint() {
  const { register_id } = useParams();

  const [register, setRegister] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRegisterReport();
  }, []);

  useEffect(() => {
    if (!loading && register) {
      setTimeout(() => window.print(), 500);
    }
  }, [loading, register]);

  const fetchRegisterReport = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(
        `${api_url}/reports/close/detail/${register_id}`
      );
      setRegister(data);
      setTransactions(data.transactions || []);
    } catch (error) {
      console.error("Error fetching register report:", error);
    }
    setLoading(false);
  };

  const payTypeReport = useMemo(() => {
    const summary = {};
    transactions.forEach((txn) => {
      const paymentType = txn.payment_type || "Unknown";
      const tax = parseFloat(txn.tax_collected || 0);
      const discount = parseFloat(txn.discount || 0);
      const orderTotal = parseFloat(txn.order_total || 0);

      if (!summary[paymentType]) {
        summary[paymentType] = {
          sales: 0,
          discounts: 0,
          tax: 0,
          total: 0,
        };
      }

      summary[paymentType].sales += orderTotal;
      summary[paymentType].discounts += discount;
      summary[paymentType].tax += tax;
      summary[paymentType].total += orderTotal + tax + discount;
    });

    return Object.entries(summary).map(([type, values]) => ({
      payment_type: type,
      ...values,
    }));
  }, [transactions]);

  if (loading || !register) {
    return (
      <div className="text-center mt-4">
        <Spinner color="primary" size="lg" />
        <p>Loading Payment Type Summary...</p>
      </div>
    );
  }

  return (
    <div className="page-body">
      <ReportPrintHeader title="EOD Summary by Payment Type" />

      <p>
        <strong>Closed At:</strong> {register.closed_at}
      </p>
      <p>
        <strong>Station:</strong> {register.station_close_number}
      </p>

      <h5 className="mt-4 mb-2">Breakdown by Payment Type</h5>
      <Table bordered responsive size="sm">
        <thead>
          <tr>
            <th>Payment Type</th>
            <th>Sales</th>
            <th>Discounts</th>
            <th>Tax</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {payTypeReport.map((type, i) => (
            <tr key={i}>
              <td>{type.payment_type}</td>
              <td>${type.sales.toFixed(2)}</td>
              <td>${type.discounts.toFixed(2)}</td>
              <td>${type.tax.toFixed(2)}</td>
              <td>${type.total.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
